/**
 *
 * Seperator
 *
 */

// @flow

import classnames from 'classnames';
import type { Node } from 'react';
import React from 'react';

import type { Props } from './types';

const Seperator = ({ extraClasses }: Props): Node => (
  <hr className={classnames('seperator', extraClasses)} />
);

Seperator.defaultProps = {};

export default Seperator;
